import ChatPanel from '../components/ChatPanel';
import HomeDashboard from '../components/HomeDashboard';
import HoldingsModal from '../components/HoldingsModal';
import './Advisor.css';

export default function Home() {
  return (
    <div className="advisor">
      <div className="working-area">
        <HomeDashboard />
        {/* Modal renders INSIDE the working area so it centers within the
            dashboard (not the viewport) and the chat panel stays visible
            while the modal is open. */}
        <HoldingsModal />
      </div>
      <ChatPanel kind="home" />
    </div>
  );
}